const DEFAULT_KAKAO_APP_KEY = "3a0f02f75a9d0aceba3f10d06c53ce53";

export const getKakaoAppKey = () => {
    try {
        const globalKey = typeof window !== "undefined"
            ? String(window.__HVM_KAKAO_APP_KEY || "").trim()
            : "";
        return globalKey || DEFAULT_KAKAO_APP_KEY;
    } catch (_e) {
        return DEFAULT_KAKAO_APP_KEY;
    }
};

export const ensureKakaoInitialized = () => {
    try {
        if (typeof window === "undefined" || !window.Kakao) return;
        const kakao = window.Kakao;
        if (typeof kakao.isInitialized === "function" && kakao.isInitialized()) return;
        if (typeof kakao.init === "function") {
            kakao.init(getKakaoAppKey());
        }
    } catch (_e) {
        // noop
    }
};
